import { z } from "zod";
const attributesCodeBlockSchema = z.object({
  lang: z.string(),
  title: z.string().optional(),
  maxHeight: z.string().optional(),
  minHeight: z.string().optional(),
  lineNumbers: z.coerce.boolean().optional().default(false),
  lineNumberStart: z.coerce.number().optional().default(0),
  highlight: z.string().optional().default(""),
  focus: z.string().optional().default(""),
  added: z.string().optional().default(""),
  removed: z.string().optional().default(""),
  fullHeight: z.coerce.boolean().optional().default(false)
});
function parseCodeBlockMeta(meta) {
  const titleSearch = meta.search(
    /([a-zA-Z-_0-9]+[ ]*=)|lineNumbers|line-numbers|lines|fullHeight|full-height|fullheight/g
  );
  const titleIdx = titleSearch === -1 ? meta.length : titleSearch;
  const title = meta.slice(0, titleIdx).trim();
  const segments = meta.slice(titleIdx).replaceAll('"', "").replaceAll("'", "").replaceAll(/[ ]*=[ ]*/g, "=").split(" ").filter(Boolean);
  const attributeMap = {
    "lines": "lineNumbers",
    "line-numbers": "lineNumbers",
    "line-number-start": "lineNumberStart",
    "full-height": "fullHeight",
    "fullheight": "fullHeight"
  };
  const properties = segments.reduce((acc, curr) => {
    const [key, value] = curr.split("=").map((s) => s.trim());
    acc[attributeMap[key] ?? key] = value ?? "true";
    return acc;
  }, {});
  const validated = attributesCodeBlockSchema.partial().safeParse(properties);
  return {
    title,
    ...validated.success ? validated.data : {}
  };
}
export {
  attributesCodeBlockSchema,
  parseCodeBlockMeta
};
//# sourceMappingURL=attributes.js.map
